import React from "react";
import { useIntl } from "react-intl";

import "./styles.scss";

import operationSteps from "~/config/operationSteps";
import ProgressBar from "./components/ProgressBar";
import { useOperation } from "~/hooks/useOperation";

const DisplayActualStep = ({
  stepIndex,
  stepsData,
  setError,
  onChange,
  stepLabel
}) => {
  const step = operationSteps[stepIndex];

  const props = {
    setError,
    data: stepsData[step.value] ?? {},
    onChange,
    stepLabel
  };

  return step.render({
    ...props
  });
};

const NewOperation = ({ setError }) => {
  const { formatMessage } = useIntl();

  const {
    loadingSave,
    actualStep,
    setActualStep,
    nextStep,
    previousStep,
    stepsFilled,
    stepsData,
    updateFields,
    operationStartFrom,
    isNewOperation
  } = useOperation();

  return (
    <>
      <h1>
        {formatMessage({
          id: isNewOperation ? "nova-operacao" : "editar-operacao"
        })}
      </h1>

      <ProgressBar
        key={operationStartFrom}
        steps={operationSteps}
        startFrom={operationStartFrom}
        currentStep={actualStep}
        stepsFilled={stepsFilled}
        onChange={selectedStep => setActualStep(selectedStep)}
      />

      <div className="content-box">
        <DisplayActualStep
          stepIndex={actualStep}
          stepsData={stepsData}
          setError={setError}
          onChange={updateFields}
          stepLabel={formatMessage({
            id: operationSteps[actualStep]?.value
          })}
        />
      </div>

      <div className="steps-control">
        <div>
          {actualStep > 0 && (
            <button
              type="button"
              onClick={() => previousStep()}
              className="steps-control-button"
              disabled={loadingSave}
            >
              {formatMessage({ id: "etapa-anterior" })}
            </button>
          )}
        </div>
        <div>
          {actualStep < operationSteps.length - 1 && (
            <button
              type="button"
              onClick={() => nextStep(0, setError)}
              className="steps-control-button"
              disabled={loadingSave}
            >
              {formatMessage({ id: "etapa-proximo" })}
            </button>
          )}
        </div>
      </div>
    </>
  );
};

export default NewOperation;
